<app-base-entry-dialog-template [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving"
                                (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()">
  <app-vendor-form
    [(formGroupRef)]="formGroupRef"
    [(value)]="value">
  </app-vendor-form>
</app-base-entry-dialog-template>
